import { createCompanyPeopleHeroContent } from './companyPeopleHeroContent.js';
import { companyHeroCopy, companyObjectionsCopy } from './companyHomeContent.js';
import { createMatchingContent } from './landingMatchingContent.js';
import type { LandingContent } from './landingContentTypes.js';
import * as shared from './landingContentShared.js';
const { industryCare, industryCraft, industryGastro, heroPflege, heroGastro, heroHandwerk, heroHandel, heroUnternehmenBedarf, heroUnternehmenBranchen, heroUnternehmenDokumente, heroUnternehmenIntegration, partnerGlobus, partnerTempusleben, partnerEmek, groupPhoto, assets, contact } = shared;
import { deContent } from './landingContent.de.js';

export const trContent: LandingContent = {
  ...deContent,
  locale: 'tr',
  languageLabel: 'Türkçe',
  nav: [
    { label: 'Bakım', href: '/branchen/pflege' },
    { label: 'Gastro', href: '/branchen/gastro' },
    { label: 'Zanaat', href: '/branchen/handwerk' },
    { label: 'Perakende', href: '/branchen/einzelhandel' },
  ],
  hero: {
    eyebrow: 'Sorumlu uluslararası işe yerleştirme',
    title: 'Viva Porta insanları',
    highlight: 'gelecekle buluşturur',
    videoUrl: '',
    intro: 'Viva Porta, Almanya’daki şirketleri burada profesyonel bir başlangıç yapmak isteyen uluslararası insanlarla buluşturur. Kişisel, güvenilir ve uzun vadeli düşünülmüş bir süreçle.',
    bullets: ['Bakım, gastronomi, zanaat ve perakende için açık sektör çözümleri', 'Şirketler ve adaylar için kişisel danışmanlık', 'İlk görüşmeden Almanya’daki başlangıca kadar güvenilir süreç'],
    primaryAction: { label: 'Adaylar için', href: contact.application },
    secondaryAction: { label: 'Sektörleri incele', href: '#branchen' },
    imageAlt: 'Viva Porta’nın insan odaklı uluslararası işe yerleştirme yaklaşımı',
    trustLabels: ['Kişisel destek', 'Şirketler ve adaylar', 'Uzun vadeli entegrasyon'],
  },
  heroApplicant: {
    badge: '1.500+ hemşireye katıl',
    avatars: [assets.nursePortrait1, assets.nursePortrait2, assets.nursePortrait3],
    title: 'Daha çok gelecek. Daha çok güven. Daha çok sen.',
    highlight: 'Daha çok sen.',
    intro: 'Türkiye’den hemşireleri adım adım, kişisel olarak Almanya’ya götürüyoruz.',
    trustLabel: 'Trustpilot 4,9 / 5 · 320+ değerlendirme',
    cards: [
      {
        eyebrow: 'Dil',
        title: 'Güvenle Almanca konuş',
        image: assets.nursePortrait1,
        imageAlt: 'Almanca öğrenen hemşire',
        href: '/ablauf',
      },
      {
        eyebrow: 'Denklik',
        title: 'Mesleğini tanıt',
        image: assets.nursePortrait2,
        imageAlt: 'Belgeleri onaylı hemşire',
        href: '/ablauf',
      },
      {
        eyebrow: 'Uyum',
        title: 'Almanya’da yerleş',
        image: assets.nursePortrait3,
        imageAlt: 'Yeni iş ortamında hemşire',
        href: contact.application,
      },
    ],
  },
  heroCompany: {
    badge: '40+ kurum bize güveniyor',
    avatars: [assets.nursePortrait3, assets.nursePortrait1, assets.nursePortrait2],
    title: 'Daha çok uzman. Daha çok güven. Daha çok ekip.',
    highlight: 'Daha çok ekip.',
    intro: 'Türkiye’den onaylı hemşireler – hukuki güvenceyle ve tam destekle.',
    trustLabel: 'Hukuki güvence · Denklik desteği dahil',
    cards: [
      {
        eyebrow: 'Uzmanlar',
        title: 'Onaylı hemşireler',
        image: assets.nursePortrait2,
        imageAlt: 'Onaylı hemşire',
        href: contact.medical,
      },
      {
        eyebrow: 'Güvence',
        title: 'Sorunsuz işe alım',
        image: assets.nursePortrait1,
        imageAlt: 'Klinik ortamında hemşire',
        href: '/kontakt',
      },
      {
        eyebrow: 'Destek',
        title: 'Tam destek',
        image: assets.nursePortrait3,
        imageAlt: 'Destek alan hemşire',
        href: '/ablauf',
      },
    ],
  },
  heroFanApplicant: {
    badge: 'Yurt dışından gelen adaylar için',
    avatars: [industryCare, industryGastro, industryCraft],
    title: 'Almanya’daki mesleki başlangıcın burada başlar.',
    highlight: 'burada başlar.',
    intro: 'Almanya’da çalışmak istiyor ve güvenilir bir yol mu arıyorsun? Viva Porta sana uygun sektörleri gösterir, sonraki adımları açıklar ve varışına kadar kişisel olarak yanında olur.',
    trustLabel: '',
    cards: [
      {
        eyebrow: 'Bakım',
        title: 'Bakım alanında başla',
        image: heroPflege,
        imageAlt: 'Aydınlık modern bir bakım ortamında bakım uzmanı',
        href: '/branchen/pflege',
      },
      {
        eyebrow: 'Gastro',
        title: 'Servis veya mutfakta çalış',
        image: heroGastro,
        imageAlt: 'Modern bir restoranda çalışan servis personeli',
        href: '/branchen/gastro',
      },
      {
        eyebrow: 'Zanaat',
        title: 'Zanaatte emek ver',
        image: heroHandwerk,
        imageAlt: 'Aydınlık bir atölyede çalışan zanaat uzmanı',
        href: '/branchen/handwerk',
      },
      {
        eyebrow: 'Perakende',
        title: 'Mağazada insanlara yardımcı ol',
        image: heroHandel,
        imageAlt: 'Modern bir mağazada çalışan perakende personeli',
        href: '/branchen/einzelhandel',
      },
    ],
  },
  heroFanCompany: {
    badge: 'Almanya’daki işverenler için',
    avatars: [industryCare, industryGastro, industryCraft],
    title: 'Ekibine gerçekten uyan uluslararası çalışanlar.',
    highlight: 'gerçekten uyan',
    intro: 'Güvenilir uluslararası çalışanlar mı arıyorsunuz? Viva Porta ihtiyacınızı netleştirir, profilleri inceler, formaliteleri koordine eder ve işe uyumu destekler.',
    trustLabel: '',
    cards: [
      {
        eyebrow: 'İhtiyaç',
        title: 'Personel ihtiyacını netleştir',
        image: heroUnternehmenBedarf,
        imageAlt: 'İşverenle danışmanlık görüşmesi',
        href: '#ablauf',
        quote: 'İlk görüşmede hangi profillerin gerçekçi olduğu ve ekibimizin hangi adımlara hazırlanması gerektiği netleşti.',
        quoteAuthor: 'İK yönetimi',
        quoteRole: 'Orta ölçekli işveren',
      },
      {
        eyebrow: 'Sektörler',
        title: 'Gerçek rollere uygun profiller',
        image: heroUnternehmenBranchen,
        imageAlt: 'Modern bir gastronomi işletmesinde servis ekibi',
        href: '#branchen',
        quote: 'Anonim özgeçmişler değil, süreçlerimize uygun şekilde önceden kontrol edilmiş profiller aldık.',
        quoteAuthor: 'İşletme yönetimi',
        quoteRole: 'Gastronomi ve servis',
      },
      {
        eyebrow: 'Formaliteler',
        title: 'Belgeler koordine edilir',
        image: heroUnternehmenDokumente,
        imageAlt: 'Uluslararası işe alım için belgeler ve dijital planlama',
        href: '#ablauf',
        quote: 'Denklik, vize ve evraklar şeffaf şekilde yapılandırılmıştı. İç ekibimiz sıradaki adımı her zaman biliyordu.',
        quoteAuthor: 'Personel yönetimi',
        quoteRole: 'Bakım kurumu',
      },
      {
        eyebrow: 'Uyum',
        title: 'Ekibe uyumu destekle',
        image: heroUnternehmenIntegration,
        imageAlt: 'Uluslararası uzman ekipte karşılanıyor',
        href: '#kontakt',
        quote: 'Başlangıçtan sonraki destek, soruları erken çözmemize ve yeni çalışma arkadaşlarını kalıcı biçimde ekibe katmamıza yardımcı oldu.',
        quoteAuthor: 'Kurum yönetimi',
        quoteRole: 'Almanya’da işveren',
      },
    ],
  },
  companyPlatformHero: { ...companyHeroCopy.tr, matching: createMatchingContent('tr') },
  companyPeopleHero: createCompanyPeopleHeroContent('tr'),
  companyObjections: companyObjectionsCopy.tr,
  intro: {
    eyebrow: 'Hoş geldin',
    title: 'Almanya yolculuğun net, planlı ve insani bir destekle ilerler.',
    titleHighlight: 'ilerler',
    text: 'Viva Porta’nın vize ve relokasyon deneyimini uluslararası kariyer yollarına dair kapsamlı bilgiyle birleştiriyoruz. Böylece Almanya’da kariyer kurmak isteyen insanlar için yönetilebilir bir süreç oluşur.',
    metrics: [
      { value: '360°', label: 'Dil, denklik, vize ve başlangıç için bütünsel destek' },
      { value: '2', label: 'İki kültür, tek ekip: Almanya ve Türkiye' },
      { value: '24/7', label: 'Kritik aşamalarda ulaşılabilir destek' },
    ],
  },
  reasons: {
    eyebrow: 'Neden Viva Porta?',
    title: 'Almanya’da sağlık kariyerine başlamak için güçlü nedenler.',
    titleHighlight: 'nedenler',
    image: assets.article,
    text: 'Almanya güvenli iş ortamı, modern sağlık yapıları ve güçlü kariyer imkanları sunar. Viva Porta bu fırsatı planlı bir başlangıca dönüştürür.',
    cards: [
      {
        iconClass: 'icon-[material-symbols--groups]',
        title: 'Güçlü topluluk',
        text: 'Almanya’daki büyük Türk topluluğu günlük hayata, işe ve sosyal çevreye uyumu kolaylaştırır.',
      },
      {
        iconClass: 'icon-[material-symbols--flight-takeoff]',
        title: 'Memlekete yakın',
        text: 'Türkiye ile Almanya arasındaki direkt uçuşlar yeni hayatını ailenle yakın tutar.',
      },
      {
        iconClass: 'icon-[material-symbols--verified-user]',
        title: 'Güven ve adalet',
        text: 'Şeffaf iletişim, adil koşullar ve profiline uygun iş eşleşmesi için süreci dikkatle yönetiriz.',
      },
    ],
  },
  benefits: {
    eyebrow: 'Avantajlar',
    title: 'Senden ne beklenir değil, bizim senin için ne yaptığımız önemli.',
    titleHighlight: 'önemli',
    items: [
      {
        iconClass: 'icon-[material-symbols--school]',
        title: 'Dil ve gelişim',
        text: 'Uygun dil seviyesine kadar yönlendirme, sınav hazırlığı ve sağlık alanına özel iletişim desteği.',
      },
      {
        iconClass: 'icon-[material-symbols--approval-delegation]',
        title: 'Denklik ve belgeler',
        text: 'Evrak, çeviri, denklik başvurusu ve resmi süreçlerde adım adım destek.',
      },
      {
        iconClass: 'icon-[material-symbols--home-work]',
        title: 'Yerleşim',
        text: 'Uçuş, konaklama, kayıt, oturum ve Almanya’daki ilk günler için pratik rehberlik.',
      },
      {
        iconClass: 'icon-[material-symbols--support-agent]',
        title: 'Kişisel destek',
        text: 'İki dilli ekibimiz varış öncesinde, yolculuk sırasında ve Almanya’daki başlangıcında yanında olur.',
      },
    ],
  },
  costs: {
    eyebrow: 'Adaylar için ücretsiz',
    title: 'Almanya’ya giden yol sana ne kadara mal olur?',
    titleHighlight: 'olur',
    text: 'Viva Porta’da ön başvuru ve ilk danışmanlık ücretsizdir. Süreç boyunca hangi adımların gerektiğini ve hangi masrafların partnerler veya işverenler tarafından karşılanabileceğini şeffaf şekilde anlatırız.',
    includedTitle: 'Senin için koordine ederiz',
    excludedTitle: 'İlk adımda engel yok',
    included: ['Başvuru kontrolü', 'Dil ve denklik planı', 'Vize ve taşınma yol haritası'],
    excluded: ['Başvuru ücreti yok', 'Belirsiz ön ödeme yok', 'Gizli süreç adımı yok'],
  },
  recognition: {
    eyebrow: 'Dil ve denklik',
    title: 'Mesleğe giriş için iki temel yapı taşı.',
    titleHighlight: 'taşı',
    text: 'Almanya’da kalıcı bir hemşirelik işi için Almanca bilgisi ve mesleki denkliğin tanınması çok önemlidir. Her iki konuda da seni adım adım yönlendiririz.',
    cards: [
      {
        iconClass: 'icon-[material-symbols--translate]',
        title: 'Dil yolu',
        text: 'Almanca kursları, sınavlar ve sağlık sektörüne uygun mesleki dil için kişisel yönlendirme.',
      },
      {
        iconClass: 'icon-[material-symbols--workspace-premium]',
        title: 'Mesleki denklik',
        text: 'Belgelerinin kontrolü ve yetkili kurum kararına kadar başvuru sürecinde destek.',
      },
      {
        iconClass: 'icon-[material-symbols--clinical-notes]',
        title: 'Hazırlık',
        text: 'Kültürel atölyeler, mülakat hazırlığı ve Almanya’daki ekip hayatına pratik hazırlık.',
      },
    ],
  },
  process: {
    eyebrow: 'Almanya yolun',
    title: 'İlk görüşmeden yeni ekibindeki başlangıca kadar.',
    titleHighlight: 'başlangıca',
    text: 'Almanya’ya giden yol büyük bir adımdır, ama karmaşık olmak zorunda değil. Başvuru, işveren görüşmeleri, dil, denklik, vize, giriş ve uyum sürecinde sana adım adım eşlik ederiz.',
    steps: [
      {
        iconClass: 'icon-[material-symbols--person-search]',
        title: 'İlk görüşme',
        text: 'Eğitimini, deneyimini, hedeflerini ve mevcut Almanca seviyeni öğrenir, sana dürüst bir yol haritası veririz.',
      },
      {
        iconClass: 'icon-[material-symbols--inventory]',
        title: 'Belgeler ve profil',
        text: 'Diploma, sertifika ve belgelerini birlikte kontrol eder, profilini Almanya’daki uygun işverenler için hazırlarız.',
      },
      {
        iconClass: 'icon-[material-symbols--forum]',
        title: 'İşveren görüşmeleri',
        text: 'Sana uygun kurumları önerir, görüşmelere hazırlar ve karar sürecinde yanında oluruz.',
      },
      {
        iconClass: 'icon-[material-symbols--translate]',
        title: 'Dil',
        text: 'Günlük Almanca, mülakat, bakım meslek dili ve denklik için gereken seviyeye yönelik net bir planla ilerlersin.',
      },
      {
        iconClass: 'icon-[material-symbols--workspace-premium]',
        title: 'Denklik ve vize',
        text: 'Çeviriler, denklik başvurusu, randevular, vize belgeleri ve resmi kurumlarla iletişimde seni destekleriz.',
      },
      {
        iconClass: 'icon-[material-symbols--flight-land]',
        title: 'Giriş ve uyum',
        text: 'Seyahatten önce varış, konaklama, kayıt ve ilk günleri netleştiririz, böylece Almanya’da güvenle başlarsın.',
      },
    ],
  },
  team: {
    eyebrow: 'Kurucu ekip',
    title: 'Uzmanlık, ağ ve kişisel rehberlik.',
    titleHighlight: 'rehberlik',
    text: 'Viva Porta girişimcilik deneyimini, Alman-Türk perspektifini ve uluslararası kariyer yolları bilgisini bir araya getirir.',
    members: [
      {
        name: 'Enes Vural',
        role: 'Genel Müdür',
        text: 'Adaylar, işverenler ve entegrasyon süreci arasında kişisel bir köprü kurar.',
        story: 'Enes, Almanya’daki işveren beklentilerini ve Türkiye’den gelen adayların sorularını birlikte düşünür. Sürecin anonim başvurulardan ibaret kalmamasına, her adımın anlaşılır ve gerçekçi olmasına dikkat eder.',
        motivation: 'Amacı, adil fırsatları hem adaylar hem de işverenler için uzun vadeli ve güvenilir hale getirmektir.',
        image: assets.teamEnes,
      },
      {
        name: 'Wilhelm Josten',
        role: 'Ortak ve danışma kurulu üyesi',
        text: 'Stratejik deneyim, güçlü ağ ve sürdürülebilir yapı kurma bakışı getirir.',
        story: 'Wilhelm, uluslararası yerleştirmeyi kısa vadeli bir boşluk doldurma işi olarak değil, sorumlu bir yapı kurma görevi olarak görür. Viva Porta’nın süreç, kalite ve ortaklıklarını bu bakışla geliştirir.',
        motivation: 'İnsanî, ekonomik ve organizasyonel olarak temiz yürüyen bir modelin anlamlı olduğuna inanır.',
        image: assets.teamWilhelm,
      },
      {
        name: 'Serife Vural-Banik',
        role: 'Operasyon yönetimi',
        text: 'Adaylara iki dilde, düzenli ve güven veren bir operasyonel destek sağlar.',
        story: 'Serife başvuru soruları, belgeler, beklentiler ve kişisel kaygılar arasında adayların yanında durur. Büyük kararların daha anlaşılır olmasını ve sürecin yalnız hissedilmemesini sağlar.',
        motivation: 'Karmaşık adımları açıklamak ve her aşamada güven duygusu yaratmak onun için merkezde yer alır.',
        image: assets.teamSerife,
      },
      {
        name: 'Murat Vuval',
        role: 'Ortak ve danışma kurulu üyesi',
        text: 'Güvenilir ortaklıklar ve sorumlu büyüme için girişimci bakış açısı katar.',
        story: 'Murat, fırsatları gerçekçi değerlendirmeye ve iş birliklerini uzun vadeli düşünmeye yardımcı olur. Onun bakışı, adaylar ve işverenler için dengeli kararlar alınmasını destekler.',
        motivation: 'Yerleştirmenin sözleşmede bitmeyip gerçek katılım ve kalıcı çalışma ilişkilerine dönüşmesini önemser.',
        image: assets.teamMurat,
        linkedinUrl: 'https://www.linkedin.com/in/murat-v-113bb912/',
      },
      {
        name: 'Dr. Kirstin Wingler',
        role: 'Yönetim asistanı',
        text: 'Tıbbi anlayış, proje koordinasyonu ve dikkatli süreç takibiyle destek olur.',
        story: 'Kirstin bilimsel titizliği pratik organizasyonla birleştirir. Belgelerin, niteliklerin ve mesleki gerekliliklerin doğru değerlendirilmesine yardımcı olur.',
        motivation: 'Karmaşık fach konuları anlaşılır hale getirip çok sayıda detayı güvenilir bir sürece dönüştürmek ister.',
        image: assets.teamKirstin,
        linkedinUrl: 'https://www.linkedin.com/in/kirstin-w-43264a4/',
      },
      {
        name: 'Ergün Yalcin',
        role: 'Yönetim',
        text: 'Arka planda düzen, takip ve güvenilir idari süreçler sağlar.',
        story: 'Ergün; veriler, belgeler, koordinasyon ve idari takipte sürecin sakin ve düzenli ilerlemesine katkı sağlar. Birçok adım paralel yürürken operasyonun temelini sağlam tutar.',
        motivation: 'Adayların ve partnerlerin net, güvenilir ve düzgün işleyen bir sürece güvenebilmesini ister.',
        image: assets.teamErgun,
      },
    ],
  },
  story: {
    ...deContent.story,
    eyebrow: 'Başarı hikayesi',
    title: 'Gerçek geri bildirimler için hazırlanmış alan.',
    titleHighlight: 'geri bildirimler',
    text: 'Bu bölüm editörde aday, şirket ve partner geri bildirimleri için resim ve logo ile düzenlenebilir.',
    quote: 'İlk temastan Almanya’ya varışa kadar süreç şeffaftı. Bir sonraki adımı her zaman biliyordum ve dilimi, hedefimi anlayan bir ekibim vardı.',
    author: 'Viva Porta adayı',
    role: 'Türkiye’den gelen hemşire',
    partnerLogo: assets.partner,
    partnerSecondaryLogo: assets.partnerSecondary,
  },
  partners: {
    eyebrow: 'Partnerler & ağ',
    title: 'Güveni gerçek iş birliklerinden alan bir yaklaşım.',
    titleHighlight: 'iş birliklerinden',
    text: 'Almanya ve Türkiye’de çalışmamıza güç katan seçkin şirketler ve ağlar.',
    trustLabel: 'GVP üyesi – Almanya Personel Hizmet Sağlayıcıları Birliği',
    items: [
      {
        name: 'Globus',
        logo: partnerGlobus,
        alt: 'Globus logosu',
        description:
          'Globus gibi tam ürün yelpazesine sahip marketler için taze reyon uzmanları buluyoruz – kasap, balık ve peynir reyonu. Tam da danışmanlığın müşteri trafiği yarattığı, kâr marjını yükselttiği ve müşteriyi uzun vadeli bağladığı yerde.',
        href: '/globus',
      },
      {
        name: 'tempusleben',
        logo: partnerTempusleben,
        alt: 'tempusleben logosu',
        description: '„Viva Porta, Türkiye iş gücü piyasasında mükemmel bağlantılara sahip, son derece özverili bir iş ortağıdır. Ekibe, sundukları olanakları kanıtlama şansı verin." – Gerd Schneider, tempusleben genel müdürü.',
        href: 'https://tempusleben.de/',
      },
      {
        name: 'EMEK',
        logo: partnerEmek,
        alt: 'EMEK logosu',
        description: 'EMEK GmbH bir bakım hizmetidir. Bakım alanındaki pratik bakış, çalışma hayatına yakınlık ve insanları yalnızca yerleştirmeyen, hazırlayan bir ağ anlamına gelir.',
        href: 'https://emek-pflegedienst.de/',
      },
    ],
  },
  globusPartner: {
    eyebrow: 'Perakende partneri',
    title: 'Globus ile perakendede yeni bir başlangıç.',
    text: 'Globus, güçlü taze ürün reyonlarına sahip büyük ve hizmet odaklı marketleri temsil eder. Birlikte uluslararası yeteneklerin hazırlanabildiği, desteklendiği ve ekiplere uyum sağlayabildiği güvenilir bir çerçeve oluşturuyoruz.',
    image: groupPhoto,
    imageAlt: 'Viva Porta ekibi bir GLOBUS mağazasının kasap bölümünü ziyaret ediyor',
    logo: partnerGlobus,
    logoAlt: 'Globus logosu',
    primaryAction: { label: 'Perakendeyi incele', href: '/branchen/einzelhandel' },
  },
  info: {
    eyebrow: 'Faydalı bilgiler',
    title: 'Göç, denklik ve hemşirelik mesleği hakkında önemli kaynaklar.',
    titleHighlight: 'kaynaklar',
    links: [
      { label: 'Anerkennung in Deutschland', href: 'https://www.anerkennung-in-deutschland.de/' },
      { label: 'Make it in Germany', href: 'https://www.make-it-in-germany.com/' },
      { label: 'Bundesagentur für Arbeit', href: 'https://www.arbeitsagentur.de/' },
    ],
  },
  contact: {
    eyebrow: 'Bir sonraki adıma hazır mısın?',
    title: 'Almanya’da hemşire olarak çalışmak için başvur.',
    titleHighlight: 'başvur',
    text: 'Bize başvurunu gönder. Sana gerçekçi bir değerlendirme ve kişisel yol haritanla geri dönelim.',
    primaryAction: { label: 'Ücretsiz başvur', href: contact.application },
    secondaryAction: { label: 'E-posta gönder', href: contact.mail },
    address: 'Viva Porta GmbH, Almanya',
    email: 'info@vivaporta.org',
    hours: 'Pzt - Cum: 9.00 - 17.00',
  },
  requirements: {
    eyebrow: 'Ön koşullar',
    title: 'Almanya’da başlamak için bunlara ihtiyacın var.',
    titleHighlight: 'Almanya’da',
    text: 'Her şeyi tek başına halletmek zorunda değilsin. Sen eğitimini ve motivasyonunu getir – gerisini adım adım birlikte organize ederiz.',
    columns: [
      {
        iconClass: 'icon-[material-symbols--person-check]',
        title: 'Senin getirdiklerin',
        items: [
          'Türkiye’de tamamlanmış hemşirelik eğitimi veya hemşirelik lisansı',
          'Almancayı en az B1/B2 seviyesine kadar öğrenme motivasyonu',
          'Yeni mesleğin için Almanya’ya taşınmaya hazır olmak',
          'Geçerli pasaport ve eksiksiz eğitim belgeleri',
        ],
      },
      {
        iconClass: 'icon-[material-symbols--volunteer-activism]',
        title: 'Bizim üstlendiklerimiz',
        items: ['Sınavlı dil seviyesine kadar ücretsiz Almanca kursları', 'Diplomanın denkliği – çeviriler ve resmi işlemler dahil', 'Vize, giriş ve ilk konut arayışı', 'İlk görüşmeden Almanya’ya varışından sonrasına kadar kişisel destek'],
      },
    ],
  },
  faqApplicant: {
    eyebrow: 'Hemşireler için SSS',
    title: 'Başvurundan önce en önemli sorular.',
    titleHighlight: 'başvurundan',
    text: 'Sorunun cevabı burada yoksa bizi ara – seni ücretsiz ve Türkçe olarak bilgilendiriyoruz.',
    items: [
      {
        question: 'Aracılık bana ne kadara mal olur?',
        answer: 'Ücretlerin büyük kısmını işverenin senin adına karşılar. Bu nedenle işe yerleştirme senin için genel olarak ücretsizdir. Ancak mesleğe ve sektöre bağlı olarak danışmanlık ücretleri oluşabilir. Daha fazla bilgi almak istersen bizimle iletişime geçebilirsin.',
      },
      {
        question: 'Hangi dil seviyesine ihtiyacım var?',
        answer: 'Almanya’daki bir işveren, çalışma arkadaşların ve müşterilerle iletişim kurabilmen için uzun vadede Almanca konuşmanı doğal olarak bekler. Ancak mesleğine bağlı olarak kusursuz Almanca bilmeden de Almanya’ya giriş yapabilirsin. Dikkat: Bakım çalışanlarının vize için en az B1 seviyesinde Almanca bilmesi gerekir.',
      },
      {
        question: 'Türkiye’deki diplomam tanınır mı?',
        answer: 'Tüm denklik süreci boyunca sana eşlik eder, diplomanın Almanya’da tanınıp tanınamayacağını ve bunun hangi koşullara bağlı olduğunu önceden değerlendiririz.',
      },
      {
        question: 'Tüm süreç ne kadar sürer?',
        answer: 'Ne yazık ki buna herkes için geçerli tek bir yanıt vermek mümkün değil; süreç büyük ölçüde yetkili kurumlara bağlıdır. İşlem süreleri Almanya’daki eyaletlere göre değişir ve her başvuru bireysel olarak değerlendirilir. Deneyimlerimize göre mesleğe bağlı olarak Almanya’ya giriş yapabilmen yaklaşık üç ila on iki ay sürer.',
      },
      {
        question: 'Önceden iş sözleşmesi alıyor muyum?',
        answer: 'Elbette. İş sözleşmesi, denklik sürecini başlatmak ve vize başvurusu yapmak için önemli bir ön koşuldur.',
      },
      {
        question: 'Almanya’ya geldikten sonra resmî işlemler ve ilk konaklama konusunda da yardımcı oluyor musunuz?',
        answer: 'Evet. İlk resmî işlemlerinde sana eşlik eder, önemli sigorta ve sözleşmeleri tamamlamana yardımcı oluruz. Ayrıca konut arayışında da seni destekleriz.',
      },
    ],
  },
  faqCompany: {
    eyebrow: 'İşverenler için SSS',
    title: 'Klinikler ve bakım kurumları için yanıtlar.',
    titleHighlight: 'bakım kurumları',
    text: 'Süreç, maliyet veya hukuki konularda başka sorularınız mı var? Doğrudan ekibimizle konuşun.',
    items: [
      {
        question: 'Aracılık ne kadara mal olur?',
        answer: 'Başarıya dayalı ödersiniz – maliyet yalnızca başarılı yerleştirmede doğar. Gizli ücret yoktur, eşit düzeyde şeffaf bir model sunarız.',
      },
      {
        question: 'Hemşirelerin nitelikleri nedir?',
        answer: 'Tüm adaylar diplomalı hemşirelerdir; yapılandırılmış bir ön seçimden geçer, B1/B2 dil seviyesi belgelenir ve denklik süreci yürür ya da tamamlanmıştır.',
      },
      {
        question: 'Denklik ve bürokrasiyi siz mi üstleniyorsunuz?',
        answer: 'Evet. Belgeleri, çevirileri, denklik başvurusunu, vize ve çalışma iznini eksiksiz yönetir, ekibinizi belirgin şekilde rahatlatırız.',
      },
      {
        question: 'İşe başlamaya kadar ne kadar sürer?',
        answer: 'Siparişten itibaren genellikle 12 ila 18 ay – dil, denklik ve giriş dahil. Sabit irtibat kişileri ve şeffaf zaman planları alırsınız.',
      },
      {
        question: 'Girişten sonra ne olur?',
        answer: 'Oryantasyon ve entegrasyona ilk iş gününün ötesinde eşlik eder, kalıcı bir başlangıç için irtibat kişiniz olarak kalırız.',
      },
      {
        question: 'Neden Türkiye’den hemşireler?',
        answer: 'Türkiye hemşireleri yüksek düzeyde yetiştirir. Kültürel yakınlık, Almanya’daki büyük topluluk ve kısa direkt uçuşlar daha hızlı uyum ve yüksek kalıcılık sağlar.',
      },
    ],
  },
  quality: {
    eyebrow: 'Kalite ve Entegrasyon',
    title: 'Ekibe kalıcı şekilde uyum sağlayan adil aracılık.',
    titleHighlight: 'kalıcı',
    text: 'Bizim için başarılı aracılık havalimanında bitmez. Denetlenmiş kalite ve gerçek entegrasyon, yeni hemşirelerinizin uzun vadeli kalmasını sağlar.',
    stats: [
      { value: '%95', label: 'Yerleştirilen uzmanların kalıcılık oranı' },
      { value: 'B1/B2', label: 'İlk iş gününden önce belgelenmiş dil seviyesi' },
      { value: '24/7', label: 'Kritik başlangıç aşamasında destek' },
    ],
    points: [
      {
        iconClass: 'icon-[material-symbols--verified]',
        title: 'Adil işe alım',
        text: 'Adil işe alım ilkelerine göre çalışırız – şeffaf, hukuka uygun ve DSÖ yönergeleri doğrultusunda.',
      },
      {
        iconClass: 'icon-[material-symbols--diversity-3]',
        title: 'Kültürel entegrasyon',
        text: 'Kültürlerarası atölyeler ve kişisel destek, uzmanların ekibe ve günlük hayata hızla uyum sağlamasına yardımcı olur.',
      },
      {
        iconClass: 'icon-[material-symbols--health-and-safety]',
        title: 'Kalite denetimli',
        text: 'Mesleki yeterlilik, dil sertifikası ve denklik süreci aracılıktan önce izlenebilir şekilde belgelenir.',
      },
      {
        iconClass: 'icon-[material-symbols--handshake]',
        title: 'Uzun vadeli bağ',
        text: 'Sonraki destek ve oryantasyon, dalgalanmayı azaltır ve istihdamın kalıcı başarısını güvence altına alır.',
      },
    ],
  },
  knowledge: {
    eyebrow: 'Bilgi ve Rehber',
    title: 'Almanya yolunda iyi bilgilenmiş olmak.',
    titleHighlight: 'bilgilenmiş',
    text: 'Denklik, dil ve Almanya’da yaşam hakkında en önemli konularda yanıtlar ve yön.',
    articles: [
      {
        iconClass: 'icon-[material-symbols--workspace-premium]',
        eyebrow: 'Denklik',
        title: 'Almanya’da denklik',
        text: 'Türkiye’deki hemşirelik diplomanın nasıl tanındığı – başvurudan karara kadar.',
        linkLabel: 'Daha fazla bilgi',
        href: 'https://www.anerkennung-in-deutschland.de/',
      },
      {
        iconClass: 'icon-[material-symbols--translate]',
        eyebrow: 'Dil',
        title: 'Hemşireler için Almanca',
        text: 'Günlük Almancadan tıbbi meslek diline – dil hedefine böyle ulaşırsın.',
        linkLabel: 'Daha fazla bilgi',
        href: '/ablauf',
      },
      {
        iconClass: 'icon-[material-symbols--home-work]',
        eyebrow: 'Yaşam',
        title: 'Almanya’da yaşam ve çalışma',
        text: 'Konut, resmi işlemler, maaş ve günlük hayat: yeni yuvanda seni neler bekliyor.',
        linkLabel: 'Daha fazla bilgi',
        href: 'https://www.make-it-in-germany.com/',
      },
      {
        iconClass: 'icon-[material-symbols--balance]',
        eyebrow: 'Adalet',
        title: 'Adil aracılık',
        text: 'Adil ve güvenilir bir aracılığı nasıl anlarsın – ve nelere dikkat etmelisin.',
        linkLabel: 'Daha fazla bilgi',
        href: '/ueber-vivaporta',
      },
    ],
  },
  values: {
    eyebrow: 'Değerlerimiz',
    title: 'Türkiye ile Almanya’yı neden birleştiriyoruz.',
    titleHighlight: 'birleştiriyoruz',
    text: 'Viva Porta, eşit düzeyde bir aracılığı temsil eder – her kararı yönlendiren net değerlerle.',
    items: [
      {
        iconClass: 'icon-[material-symbols--handshake]',
        title: 'Adillik',
        text: 'Şeffaf koşullar, gizli maliyet yok ve gerçekten insana ve pozisyona uygun bir aracılık.',
      },
      {
        iconClass: 'icon-[material-symbols--diversity-1]',
        title: 'İnsana yakınlık',
        text: 'Her aracılığın ardında bir yaşam yolu var. Kişisel, iki dilli ve gerçek bir anlayışla eşlik ederiz.',
      },
      {
        iconClass: 'icon-[material-symbols--verified-user]',
        title: 'Güvenilirlik',
        text: 'Net aşamalar, sabit irtibat kişileri ve ilk iş gününün ötesine geçen destek.',
      },
    ],
    bridgeTitle: 'Neden Türkiye ve Almanya?',
    bridgeText:
      'Türkiye yüksek nitelikli hemşireler yetiştirirken Almanya acilen uzman aramaktadır. Büyük bir Türk topluluğu, kültürel yakınlık ve kısa direkt uçuşlar bu yolu hem insani hem de günlük hayata uygun kılar – hem uzmanlar hem işverenler için.',
  },
  consultationApplicant: {
    eyebrow: 'İlk danışmanlık talep et',
    title: 'Kişisel bir görüşmeyle başla.',
    titleHighlight: 'Kişisel',
    text: 'Hedefini bize anlat. Ücretsiz bir ilk görüşmede – istersen Türkçe – ön koşullarını ve sonraki adımları netleştiririz.',
    phoneLabel: 'Hemen ara',
    phoneNumber: 'tel:+4917642887719',
    phoneDisplay: '+49 176 42887719',
    primaryAction: { label: 'Şimdi ara', href: 'tel:+4917642887719' },
    secondaryAction: { label: 'Online kayıt ol', href: contact.application },
    trustLabel: 'Ücretsiz ve bağlayıcı değil · 24 saat içinde yanıt',
  },
  consultationCompany: {
    eyebrow: 'Personel ihtiyacını görüş',
    title: 'Personel ihtiyacınızı konuşalım.',
    titleHighlight: 'Personel ihtiyacınızı',
    text: 'Hangi hemşireleri aradığınızı bize söyleyin. Bağlayıcı olmayan bir görüşmede hangi profillerin mevcut olduğunu ve ne kadar hızlı başlayabileceğimizi gösterelim.',
    phoneLabel: 'Hemen ara',
    phoneNumber: 'tel:+4917642887719',
    phoneDisplay: '+49 176 42887719',
    primaryAction: { label: 'Şimdi ara', href: 'tel:+4917642887719' },
    secondaryAction: { label: 'Danışmanlık talep et', href: contact.medical },
    trustLabel: 'Başarıya dayalı · Sabit irtibat kişileri · 24 saat içinde yanıt',
  },
  footer: {
    text: 'Viva Porta, Almanya’daki şirketleri ve uluslararası insanları adil, şeffaf ve kişisel bir süreçle buluşturur.',
    links: [
      { label: 'Ana sayfa', href: '/' },
      { label: 'Bakım', href: '/branchen/pflege' },
      { label: 'Gastro', href: '/branchen/gastro' },
      { label: 'Zanaat', href: '/branchen/handwerk' },
      { label: 'Perakende', href: '/branchen/einzelhandel' },
      { label: 'Viva Porta hakkında', href: '/ueber-vivaporta' },
      { label: 'İletişim', href: '/kontakt' },
      { label: 'Künye', href: '/impressum' },
    ],
    socialLinks: deContent.footer.socialLinks,
  },
};
